import { useContext } from 'react';
import { FiltersPublicApiContext } from './FiltersPublicApiProvider';

export default function useFiltersPublicApiContext() {
    return useContext(FiltersPublicApiContext);
};
